import { useEffect, useRef, useState } from 'react'

import styles from './Accordionitem.module.css'

export type AccordionitemProps = {
  title: string
  content: any
  variant?: 'primary' | 'secondary'
}

export const PhnxAccordionitem: React.FC<AccordionitemProps> = ({
  title,
  content,
  variant = 'primary',
}) => {
  const [isOpen, setIsOpen] = useState(false)
  const contentRef = useRef<HTMLDivElement>(null)

  const toggleAccordion = () => {
    setIsOpen(!isOpen)
  }

  useEffect(() => {
    if (contentRef.current) {
      contentRef.current.style.maxHeight = isOpen ? `${contentRef.current.scrollHeight}px` : '0'
    }
  }, [isOpen])

  return (
    <div className={`container ${styles['accordionitem']} ${styles[`variant-${variant}`]}`}>
      {variant === 'primary' && (
        <>
          <button
            className={styles['accordionitem__button']}
            onClick={toggleAccordion}
            aria-expanded={isOpen}
            aria-controls="accordion-content"
          >
            <div className={styles.title}>{title}</div>
            <div className={`${styles.icon} ${isOpen ? styles.open : ''}`}>
              <span className="fx-icon fx-icon-arrow-down-lg"></span>
            </div>
          </button>
          <div
            id="accordion-content"
            ref={contentRef}
            className={`${styles['accordionitem__content']} ${isOpen ? 'open' : ''} richText`}
          >
            <div className={styles.inner}>{content}</div>
          </div>
        </>
      )}
      {variant === 'secondary' && (
        <>
          <button
            className={styles['accordionitem__button_secondary']}
            onClick={toggleAccordion}
            aria-expanded={isOpen}
            aria-controls="accordion-content"
          >
            <div className={styles['accordionitem_button_title']}>
              <div className={styles.title}>{title}</div>
              <div className={`${styles.icon} ${isOpen ? styles.open : ''}`}>
                <span className="icon">{isOpen ? '-' : '+'}</span>
              </div>
            </div>
            <div
              id="accordion-content"
              ref={contentRef}
              className={`${styles['accordionitem__content']} ${isOpen ? 'open' : ''} richText`}
            >
              <div className={styles.inner}>{content}</div>
            </div>
          </button>
        </>
      )}
    </div>
  )
}
